import { ItemAspect } from "./item_aspect";
import { ConditionPanel } from "./condition_panel";
import $ from "jquery";

class RankingForm {
  private conditionPanel: ConditionPanel;
  private itemAspect: ItemAspect;

  constructor() {
    this.conditionPanel = new ConditionPanel(this.formElement());
    this.itemAspect = new ItemAspect();
  }

  private formElement(): JQuery {
    return $("#rankings_form");
  }

  private typeElement(): JQuery {
    return $("#type");
  }

  private partitionElement(): JQuery {
    return $("#partition");
  }

  getType(): string {
    return this.typeElement().val() as string;
  }

  getPartition(): string {
    return this.partitionElement().val() as string;
  }

  initialize(): void {
    const invalidParameterCombinations = this.formElement().data(
      "invalidParameterCombinations",
    );
    this.conditionPanel.initialize(invalidParameterCombinations);
    this.initializeEventHandlers();
  }

  private initializeEventHandlers(): void {
    this.itemAspect.onAspectChange((aspect: string) => {
      this.itemAspect.flipSelectedAspect(aspect);
      this.submit();
    });
  }

  submit(): void {
    this.formElement().submit();
  }
}

export { RankingForm };
